import { cn } from '@/lib/utils'
import type { ProfileTabId } from './profile-utils'
import { getProfileTabLabel } from './profile-utils'

interface ProfileTabNavProps {
  tabs: ProfileTabId[]
  active: ProfileTabId
  onChange: (tab: ProfileTabId) => void
  isSelf: boolean
}

export function ProfileTabNav({ tabs, active, onChange, isSelf }: ProfileTabNavProps) {
  return (
    <div
      className="flex gap-1 overflow-x-auto border-b border-border-2"
      role="tablist"
      aria-label="Profile sections"
    >
      {tabs.map((tab) => {
        const isActive = tab === active
        return (
          <button
            key={tab}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab)}
            className={cn(
              'relative shrink-0 px-4 py-3 font-sans text-sm font-medium transition-colors duration-150',
              isActive ? 'text-ink' : 'text-muted-foreground hover:text-ink',
            )}
          >
            {getProfileTabLabel(tab, isSelf)}
            {isActive && (
              <span className="absolute inset-x-0 bottom-0 h-0.5 bg-green" aria-hidden />
            )}
          </button>
        )
      })}
    </div>
  )
}
